import React from 'react';

const UrlErrorPage = () => {
  return (
    <>
      <div
        style={{
          height: '100%',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <h1
          style={{
            color: 'red',
            fontWeight: 'bolder',
          }}
        >
          404 page not found !
        </h1>
      </div>
    </>
  );
};

export default UrlErrorPage;
